// Piezas comunes de la app «Google». Solo tokens semánticos.
import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, CircleDashed, X } from 'lucide-react';

export function Insignia({ tono, children }: { tono: 'ok' | 'aviso' | 'neutro'; children: ReactNode }) {
  const cls = { ok: 'bg-primary/10 text-primary', aviso: 'bg-destructive/10 text-destructive', neutro: 'bg-muted text-muted-foreground' }[tono];
  const Icon = tono === 'ok' ? CheckCircle2 : tono === 'aviso' ? AlertTriangle : CircleDashed;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${cls}`}>
      <Icon size={13} aria-hidden /> {children}
    </span>
  );
}

export function Aviso({ tono, children, onClose }: { tono: 'ok' | 'error'; children: ReactNode; onClose?: () => void }) {
  return (
    <div role="status" className={`mb-4 flex items-start gap-2 rounded-xl border px-3 py-2 text-sm text-foreground ${tono === 'ok' ? 'border-primary/30 bg-primary/10' : 'border-destructive/30 bg-destructive/10'}`}>
      <span className="flex-1">{children}</span>
      {onClose && (
        <button type="button" onClick={onClose} aria-label="Cerrar aviso" className="rounded p-0.5 text-muted-foreground hover:text-foreground">
          <X size={14} aria-hidden />
        </button>
      )}
    </div>
  );
}
